<template>
  <div v-if="shouldShow">
    <slot></slot>

    <AgeField v-if="ageField" />
    <TermsField v-if="termsField" required />
  </div>
</template>

<script lang="ts">
export type FormStepProps = {
  ageField?: boolean;
  termsField?: boolean;
};
</script>

<script lang="ts" setup>
import { computed } from "vue";
import TermsField from "../fields/TermsField.vue";
import { useFormWizardContext } from "./FormWizard.vue";
import AgeField from "../fields/AgeField.vue";

defineProps<FormStepProps>();

const { currentStepIdx, stepCounter } = useFormWizardContext();
// Get the step's index and advances it by 1 for the next step
// meaning each step gets a index id starting from 1
const currentIdx = stepCounter.value++;

// If this step should be shown
const shouldShow = computed(() => {
  return currentIdx === currentStepIdx.value;
});
</script>
